import { useEffect, useState } from "react";
import FingerprintJS, { type Agent } from "@fingerprintjs/fingerprintjs";

const CACHE_KEY = "fpjs_cache";
const CACHE_TTL = 1000 * 60 * 60 * 24; // basic 24 hrs for now this will be updated

type CachedFP = {
  visitorId: string;
  timestamp: number;
}

// TODO: implement caching
export function useFingerprint() {
  const [visitorId, setVisitorId] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const loadFingerprint = async () => {
      try {
        const cached = localStorage.getItem(CACHE_KEY);
        if (cached) {
          const parsed: CachedFP = JSON.parse(cached);
          // going to skip this for now 
          // const isExpired = Date.now() - parsed.timestamp > CACHE_TTL;
          const isExpired = false;

          if (!isExpired) {
            setVisitorId(parsed.visitorId);
            setLoading(false);
            return;
          }
        }

        const fp: Agent = await FingerprintJS.load();
        const fpResult = await fp.get();

        if (!isMounted) return;

        const cacheData: CachedFP = {
          visitorId: fpResult.visitorId,
          timestamp: Date.now(),
        };

        localStorage.setItem(CACHE_KEY, JSON.stringify(cacheData));

        setVisitorId(fpResult.visitorId);
      } catch (err) {
        console.error("Failed to load fingerprint:", err);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    loadFingerprint();

    return () => {
      isMounted = false;
    };
  }, []);

  return { visitorId, loading };
}

export default useFingerprint;
